var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[_vm.className, 'pokemon-type-' + _vm.PokemonTypes[_vm.id]],on:{"click":function($event){return _vm.goPokemonList($event, _vm.PokemonTypes[_vm.id])}}},[_vm._v(" "+_vm._s(_vm.PokemonTypes[_vm.id])+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }